import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as pseCaptchaActions } from '@/domain/useCases/procedures/pse/getCaptcha';
import { Creators as pseRegisterActions } from '@/domain/useCases/procedures/pse/registerInsuranceValidation';
import PseRegisterView from './PseRegisterView';
import IDHelpers from '@/core/helpers/IDHelper';
import { useRegisterValidationEffect } from './useRegisterValidationEffect';
import useProfile from '@/presentation/hooks/useProfile';

const PseRegisterViewController = () => {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [unHappyPath, setUnHappyPath] = useState(false);
  const [manualPath, setManualPath] = useState(false);
  const [openBack, setOpenBack] = useState(false);
  const [selectPeriod, setSelectPeriod] = useState(null);
  const [textCaptcha, setTextCaptcha] = useState('');
  const [base64, setBase64] = useState<any>([]);
  const [terms, setTerms] = useState(false);
  const [check, setCheck] = useState(false);
  const [successBadPath, setSuccessBadPath] = useState(false);
  const [errorCaptcha, setErrorCaptcha] = useState(false);
  const [defaultError, setDefaultError] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [payPSE, setPayPSE] = useState(false);
  const [checkDocument, setCheckDocument] = useState(false);
  const [checkDeclaration, setCheckDeclaration] = useState(false);
  const [systemError, setSystemError] = useState(false);

  const history = useHistory();
  const { profile } = useProfile();

  const { procedure: procedureInfo, isLoading: isLoadingProcedure } =
    useSelector((state: any) => state.procedureInformation);

  const { data: imgCaptcha, isLoading: isLoadingCaptcha } = useSelector(
    (state: any) => state.getCaptcha
  );
  const {
    isLoading: isProcessingRegister,
    data: registerInsuranceValidation,
    error: errorInRegisterInsuranceValidation
  } = useSelector((state: any) => state.registerInsuranceValidation);

  useRegisterValidationEffect(registerInsuranceValidation, {
    setSuccess,
    setPayPSE,
    setSuccessBadPath,
    setUnHappyPath,
    setManualPath,
    setErrorCaptcha,
    setDefaultError,
    setFileError,
    setSystemError
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!procedureInfo && !isLoadingProcedure) {
      history.push('/tramites');
    }
  }, [isLoadingProcedure]);

  useEffect(() => {
    // dispatch(pseCaptchaActions.getCaptcha());
    setSelectPeriod(
      procedureInfo?.detail?.periodApplied?.length === 1
        ? procedureInfo?.detail?.periodApplied[0]?.id
        : null
    );
    setTextCaptcha('');
    setCheck(false);
    return () => {
      dispatch(pseRegisterActions.RegisterPseClear());
    };
  }, []);

  const register = (isAutomated: boolean) => {
    const files =
      base64?.length > 0
        ? base64.map((item: any) => ({
            content: item.base64,
            fileName: `${profile?.studentCode}-${IDHelpers.generateIDString(
              5
            )}.pdf`
          }))
        : [];

    dispatch(
      pseRegisterActions.RegisterPse(
        selectPeriod,
        checkDocument,
        checkDeclaration,
        files,
        isAutomated
      )
    );
  };

  const validation = () => {
    history.push('/tramites');
  };
  const validation2 = () => {
    history.push('/pagos');
  };

  const handlerBackButton = () => {
    history.push('/tramites');
  };

  return (
    <PseRegisterView
      isProcessingRegister={isProcessingRegister}
      goToPayments={validation2}
      goToProgress={validation}
      errorInput={{
        errorCaptcha
      }}
      manualPath={manualPath}
      payed={{
        payPSE,
        setPayPSE
      }}
      defaultMessage={{
        defaultError,
        setDefaultError
      }}
      reloadCaptcha={() => {
        dispatch(pseCaptchaActions.getCaptcha());
      }}
      open={{
        openBack,
        setOpenBack
      }}
      sendFiles={{
        base64,
        setBase64
      }}
      requestId={registerInsuranceValidation}
      requestMessage={registerInsuranceValidation}
      path={{
        unHappyPath,
        setUnHappyPath
      }}
      period={{
        selectPeriod,
        setSelectPeriod
      }}
      termsConditions={{
        terms,
        setTerms
      }}
      input={{
        textCaptcha,
        setTextCaptcha
      }}
      registerSuccess={{
        success,
        setSuccess
      }}
      checkForm={{
        check,
        setCheck
      }}
      fileValidation={{ fileError, setFileError }}
      handlerBackButton={handlerBackButton}
      procedureInfo={procedureInfo}
      isLoadingProcedure={isLoadingProcedure}
      captcha={imgCaptcha}
      isLoadingCaptcha={isLoadingCaptcha}
      register={register}
      badPath={{
        successBadPath,
        setSuccessBadPath
      }}
      checkDocumentValidation={{ checkDocument, setCheckDocument }}
      checkDeclarationValidation={{ checkDeclaration, setCheckDeclaration }}
      systemErrorValidation={{
        systemError,
        setSystemError,
        errorInRegisterInsuranceValidation
      }}
    />
  );
};

export default PseRegisterViewController;
